<div class="account" data-test="ai-credits-incentive-modal">
	<div class="account__title-box">
		<h3 class="account__title">{{ data.incentive.modalTitle }}</h3>
		<p class="account__hint">{{ data.incentive.description }}</p>
	</div>

	<form
		class="account__form"
		[formGroup]="form"
		(ngSubmit)="onSubmit()"
		novalidate
	>
		@if (data.incentive.externalCta) {
			<jepto-button
				type="flat-icon"
				size="large"
				[text]="data.incentive.externalCta.label"
				buttonType="button"
				width="100%"
				testId="ai-credits-incentive-external-cta"
				(isClicked)="openExternalCta()"
			/>
		}

		<div class="account__fields">
			<div class="account__field-group" aria-labelledby="proof-url-label">
				<span class="account__field-label" id="proof-url-label">
					{{ data.incentive.urlLabel }}
				</span>
				<div class="account__field-with-prefix">
					@if (urlPrefix()) {
						<span
							class="account__field-prefix"
							data-test="ai-credits-incentive-url-prefix"
						>
							{{ urlPrefix() }}
						</span>
					}
					<jepto-ui-input
						class="account__field account__storybook-input"
						formControlName="proofUrl"
						appearance="fill"
						floatLabel="never"
						[type]="urlPrefix() ? 'text' : 'url'"
						[placeholder]="data.incentive.urlPlaceholder"
						testId="ai-credits-incentive-proof-url"
						[errorMessage]="proofUrlError()"
					/>
				</div>
				@if (proofUrlError()) {
					<p
						class="account__field-error"
						data-test="ai-credits-incentive-proof-url-error"
					>
						{{ proofUrlError() }}
					</p>
				}
			</div>
		</div>

		@if (data.incentive.footerNote) {
			<p class="account__footer-note" data-test="ai-credits-incentive-footer-note">
				{{ data.incentive.footerNote }}
			</p>
		}

		@if (missingAccountDomain()) {
			<p
				class="account__field-error"
				data-test="ai-credits-incentive-missing-domain"
			>
				Add your website in account settings to complete this task.
			</p>
		}

		@if (submitError()) {
			<p class="account__field-error" data-test="ai-credits-incentive-error">
				{{ submitError() }}
			</p>
		}

		@if (needsAccountSettingsLink()) {
			<button
				type="button"
				class="account__settings-link"
				data-test="ai-credits-incentive-account-settings-link"
				(click)="goToAccountSettings()"
			>
				Go to account settings
			</button>
		}

		<div class="account__actions">
			<jep-button
				text="Cancel"
				color="primary"
				type="flat"
				size="large"
				buttonType="button"
				align="right"
				class="account__btn-cancel hide-for-small-only"
				(isClicked)="close()"
				data-test="cancel-button"
			/>
			<jep-button
				[isLoading]="isSubmitting()"
				text="Submit"
				color="primary"
				type="raised"
				size="large"
				buttonType="submit"
				align="right"
				class="account__btn-submit hide-for-small-only"
				[disabled]="!canSubmit()"
				data-test="submit-button"
			/>
		</div>
	</form>
</div>
